import { ButtonOutlined } from 'components/Button'
import { ROUTES } from 'config/routes'
import { CSSProperties } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const ButtonWrapper = styled.div`
  display: inline-flex;
`

interface PortfolioLinkProps {
  style?: CSSProperties
  className?: string
  onClick?: () => void
}

const PortfolioLink = ({ style, className, onClick }: PortfolioLinkProps) => {
  return (
    <ButtonWrapper style={style} className={className}>
      <ButtonOutlined
        as={Link}
        to={ROUTES.portfolio}
        onClick={onClick}
        padding="8px 12px"
        $borderRadius="6px"
        style={{
          display: 'inline-flex',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'center',
          textDecoration: 'none',
          lineHeight: '24px',
          maxHeight: '40px',
          width: 'max-content',
        }}
      >
        Portfolio 🔥
      </ButtonOutlined>
    </ButtonWrapper>
  )
}

export default PortfolioLink
